/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./gwDetails.vue?vue&type=template&id=dfa30890&scoped=true"
import script from "./gwDetails.vue?vue&type=script&lang=js"
export * from "./gwDetails.vue?vue&type=script&lang=js"
import style0 from "./gwDetails.vue?vue&type=style&index=0&id=dfa30890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa30890",
  null
  
)

export default component.exports